// extracted by mini-css-extract-plugin
export default {"root":"_3jifN","icon":"_2W7aa"};